import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { GlobalState } from "context/GlobalContext";
import React, { useEffect, useState } from "react";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import RenderInputField from "components/AudienceDashboard/ReusableComponents/RenderInputField/RenderInputField";
import { filterColArry, logsTableColumns } from "./data";
import { getColDefaultValue, isColumnDefault } from "components/EboStoreV4/data";
import { constraintsOptions, converAttrToDatagridCol } from "data/globalData";
import moment from "moment";
import DatagridWithApiPagination from "components/AudienceDashboard/ReusableComponents/DatagridWithApiPagination/DatagridWithApiPagination";
import { selectOptKeyName } from "components/ReplenishmentDashboard/data";
import { AudienceDashboardState } from "context/AudienceDashboardContext";
import axios from "axios";
import { AuthState } from "context/AuthContext";

const MoengageAudienceDataPush = () => {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const { moengDrawerListItems, setMoengDrawerListItems } = AudienceDashboardState();
	const { user } = AuthState();

	const defaultData = filterColArry?.reduce((acc, row) => {
		acc[row.key] = getColDefaultValue(row);
		return acc;
	}, {});
	const [filterData, setFilterData] = useState({ ...defaultData });
	const [logs, setLogs] = useState([]);

	const columns = [
		{
			field: "created_at",
			headerName: "Created",
			align: "center",
			headerAlign: "center",
			sortable: false,
			renderCell: ({ row, field }) => {
				if (row[field]) return moment(row[field]).format("DD/MM/YY  HH:mm");
				else return "";
			},
			flex: 1,
			minWidth: 120,
		},
		...Object.values(logsTableColumns).map((row) => converAttrToDatagridCol(row)),
		{
			headerName: "File Path",
			field: "sftp_file_path",
			align: "center",
			headerAlign: "center",
			sortable: false,
			renderCell: ({ row, field }) => {
				const handleClick = () =>
					navigator.clipboard
						.writeText(row[field])
						.then(() => {
							setSnackBarOpen(true);
							setSnackBar({
								...snackBar,
								message: `Copied to clipboard`,
								severity: "success",
								anchorOrigin: { horizontal: "center", vertical: "top" },
							});
						})
						.catch((err) => {
							console.error("Failed to copy: ", err);
						});
				return (
					<Typography component="div" onClick={handleClick} noWrap variant="body1">
						{row[field]}
					</Typography>
				);
			},
			flex: 1,
			minWidth: 120,
		},
		{
			field: "status",
			headerName: "Status",
			align: "center",
			headerAlign: "center",
			sortable: false,
			renderCell: ({ row, field }) => {
				if (row[field] === true) return "Success";
				else return "Error";
			},
			flex: 1,
			minWidth: 120,
		},
		// {
		// 	field: "progress",
		// 	headerName: "Stage",
		// 	align: "center",
		// 	headerAlign: "center",
		// 	sortable: false,
		// 	renderCell: ({ row: data, field }) => {
		// 		const row = data[field];
		// 		return <span style={{ textTransform: "capitalize" }}>{row.at(-1) ? row.at(-1)?.label?.toLowerCase() : ""}</span>;
		// 	},
		// 	flex: 1,
		// 	minWidth: 120,
		// },
		// {
		// 	field: "status_message",
		// 	headerName: "Message",
		// 	align: "center",
		// 	headerAlign: "center",
		// 	sortable: false,
		// 	flex: 1,
		// 	minWidth: 120,
		// },
	];

	const getDropdownOptions = async () => {
		setLoadingOpen(true);
		try {
			await pythonVmInstance({
				url: `/audience/Moengage_Audience`,
				headers: {
					"Content-Type": "application/json",
				},
				method: "get",
			}).then((res) => {
				setMoengDrawerListItems(res.data.result);
				setLoadingOpen(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			console.log("asdfghjkl", error);
			setSnackBar({
				...snackBar,
				message: `failed to load DropdownItems`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	useEffect(() => {
		if (!moengDrawerListItems) getDropdownOptions();
	}, []);

	const fetchLogs = async (limit, offset) => {
		try {
			const res = await axios.post(`/api/audience/get-moengage-logs-list/${offset}?limit=${limit}`);
			return res.data.result;
		} catch (error) {
			setSnackBarOpen(true);
			// console.log("asdfghjkl", error);
			setSnackBar({
				...snackBar,
				message: `failed to load DropdownItems`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};
	const handleRunQueryClick = async (e) => {
		e.preventDefault();
		setLoadingOpen(true);
		let pendingFields = [];
		filterColArry?.forEach((attr) => {
			if (isColumnDefault(attr, filterData?.[attr?.key]) && attr?.constraints?.[constraintsOptions.NOTNULL.key] === true)
				pendingFields.push(attr);
		});

		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
			return;
		}

		try {
			await pythonVmInstance({
				url: `/audience/moengage`,
				headers: {
					"Content-Type": "application/json",
				},
				method: "post",
				// responseType: "blob",
				data: {
					...filterData,
					user_email: user.email,
				},
			}).then(async (res) => {
				const { result, total_rows } = await fetchLogs(20, 0);
				setLogs(result);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: res.data.message ?? "Executed Successfully",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			console.log("asdfghjkl", error);
			setSnackBar({
				...snackBar,
				message: `failed to run query ${error}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	return (
		<Stack spacing={2} component="form" onSubmit={handleRunQueryClick}>
			{/* <Typography variant="h6">All Channel Dispatch</Typography> */}
			{/* form */}
			<Box display="flex" columnGap={2} flexWrap={"wrap"} justifyContent={""} rowGap={2} pt={2}>
				{filterColArry?.map((col) => {
					if (col.key === "table_name" && moengDrawerListItems?.["table_name"]?.length)
						col[selectOptKeyName] = {
							...col[selectOptKeyName],
							list: moengDrawerListItems?.["table_name"]?.map((row) => ({ name: row, key: row })) ?? [],
						};

					return (
						<RenderInputField
							column={col}
							data={filterData}
							setData={setFilterData}
							selectOptObjName={selectOptKeyName}
							width={"50%"}
							longWidth={"300px"}
							disabled={false}
							// error={errObj?.[column.key] ? true : false}
							// setError={setErrorObj}
							// dependencyColData={}
							disableLabel={true}
						/>
					);
				})}
				<Box alignSelf="flex-end" pb={1}>
					<Button variant="contained" sx={{ width: "150px" }} type="submit">
						Run
					</Button>
				</Box>
			</Box>
			{/* logs */}
			<Stack width="100%" height="60vh">
				<Typography variant="h6">Logs</Typography>
				<DatagridWithApiPagination
					setTableRows={setLogs}
					tableRows={logs}
					columns={columns}
					fetchTableRows={fetchLogs}
					recordsLimit={20}
					getRowId={(row) => row._id}
				/>
			</Stack>
		</Stack>
	);
};

export default MoengageAudienceDataPush;
